"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoMonNoCryInsurance = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var Resources_1 = require("../../../Resources");
var NoMonNoCryInsurance = (function (_super) {
    __extends(NoMonNoCryInsurance, _super);
    function NoMonNoCryInsurance() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.NOMON_NOCRY_INSURANCE,
            cost: 2,
            tags: [Tags_1.Tags.EARTH],
            metadata: {
                cardNumber: 'L410',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When your production is reduced, any resources are taken from you or one of your delegates is removed, gain 3 M€.', function (eb) {
                        eb.minus().production(function (pb) { return pb.wild(1); }).slash().wild(1).slash().delegates(1).startEffect.megacredits(3);
                    }).br;
                    b.production(function (pb) { return pb.megacredits(-1); });
                }),
                description: 'Reduce your M€ production 1 step.',
            },
        }) || this;
    }
    NoMonNoCryInsurance.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.MEGACREDITS) >= -4;
    };
    NoMonNoCryInsurance.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, -1);
        return undefined;
    };
    return NoMonNoCryInsurance;
}(Card_1.Card));
exports.NoMonNoCryInsurance = NoMonNoCryInsurance;
//# sourceMappingURL=NoMonNoCryInsurance.js.map